/**
 * Whether the viewport is wide enough for the full rail.
 *
 * `tokens/layout.json` already records the rule — "below the `lg` breakpoint the rail
 * collapses to `sidebar-width-collapsed` and shows icons only" — and audit v4 G-15 found it
 * was never built: on a tablet the 248px rail took a third of the screen. The threshold is the
 * `lg` TOKEN (1200px), not the mockup's 1180px, which no breakpoint in the system carries.
 *
 * A hook rather than CSS because the two rails are different controls — the narrow one opens
 * a chapter's screens in a popover — and rendering both and hiding one would put every
 * control in the document twice. Without `matchMedia` (unit tests, a server render) the rail
 * is wide, which is the rail every chrome test was written against.
 */

import { useEffect, useState } from 'react';

import { themes } from '../../tokens/generated/tokens';

const QUERY = `(min-width: ${themes.light['breakpoint-lg']})`;

function matches(): boolean {
  if (typeof globalThis.matchMedia !== 'function') return true;
  return globalThis.matchMedia(QUERY).matches;
}

export function useWideRail(): boolean {
  const [wide, setWide] = useState(matches);
  useEffect(() => {
    if (typeof globalThis.matchMedia !== 'function') return undefined;
    const query = globalThis.matchMedia(QUERY);
    const onChange = () => setWide(query.matches);
    query.addEventListener('change', onChange);
    onChange();
    return () => query.removeEventListener('change', onChange);
  }, []);
  return wide;
}
